import React from "react";
import { CustomModalProps } from "../../../types";
import CustomModal from "../../common/CustomModal";
import { IMAGE_URL } from "../../../helpers/config";
import { Image } from "antd";
type Props = {
  data?: any;
} & CustomModalProps;

export default function ViewSingleImage({ handleClose, data, ...rest }: Props) {
  return (
    <>
      <CustomModal width={800} handleClose={handleClose} {...rest}>
        <div className="w-full !h-60 shadow">
          <Image
            rootClassName="!w-full"
            className="!max-w-full !w-full !h-60 !object-cover"
            src={IMAGE_URL + data?.entryImages}
            alt=""
          />
        </div>
      </CustomModal>
    </>
  );
}
